import type { VariablesOf } from 'relay-runtime';

import { createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';
import { tqlQueryFromInput } from '@townsquare/tql/query';
import { ComparatorOperator } from '@townsquare/tql/types';

import GoalSettingsViewQuery, {
	GoalSettingsViewQuery as GoalSettingsViewQueryType,
} from '../components/GoalSettings/__generated__/GoalSettingsViewQuery.graphql';

export const goalSettingsPageResource = createRelayResource<GoalSettingsViewQueryType>({
	getQuery: (_routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const isSuccessMeasuresEnabled = fg('townsquare_goals_success_measures_prod');

		const fieldListTql = tqlQueryFromInput({
			input: [
				{
					fieldName: 'entityType',
					comparator: ComparatorOperator.EQUALS,
					fieldValue: 'GOAL',
				},
			],
		});
		const variables: VariablesOf<GoalSettingsViewQueryType> = {
			id: context.workspace?.globalId ?? '',
			workspaceUuid: context.workspace?.UUID ?? '',
			tql: fieldListTql,
			isSuccessMeasuresEnabled,
			containerId: context.collabContext?.contextId ?? '',
		};

		return {
			query: GoalSettingsViewQuery,
			variables,
		};
	},
});
